import { jsx as _jsx } from "react/jsx-runtime";
import { DatePicker } from "@mui/x-date-pickers";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
export const DoraDatePicker = (props) => {
    const { controlField, id, onChange, onAccept, value, label, disabled, minDate, maxDate, small, error, fullWidth, } = props;
    const { t } = useTranslation("components");
    return (_jsx(DatePicker, { slotProps: {
            textField: {
                size: "small",
                margin: "none",
                error: !!error,
            },
            field: { openPickerButtonPosition: "start" },
            inputAdornment: { position: "start" },
            openPickerButton: { tabIndex: -1 },
        }, displayWeekNumber: true, localeText: {
            calendarWeekNumberHeaderText: t("week"),
        }, label: label, ...(minDate && { minDate }), ...(maxDate && { maxDate }), sx: {
            margin: 0,
            svg: { color: "var(--gray-400)", fontSize: 20 },
            background: "white",
            "& .MuiInputAdornment-root": { marginRight: 0 },
            "& fieldset": { borderColor: "var(--gray-300)" },
            "& .MuiOutlinedInput-root:not(.Mui-focused):hover fieldset": {
                borderColor: "var(--gray-400) !important",
            },
            ...(fullWidth && { width: "100%" }),
            ...(small && { width: 170 }),
        }, ...(disabled && { disabled }), ...(onAccept && { onAccept }), ...(!controlField && { onChange, value }), ...(id && { id }), ...controlField }));
};
export const UFDoraDatePicker = (props) => {
    const { name, control, ...rest } = props;
    return (_jsx(Controller, { name: name, control: control, render: ({ field }) => _jsx(DoraDatePicker, { controlField: field, ...rest }) }));
};
//# sourceMappingURL=DoraDatePicker.js.map